import { createContext, useContext, useMemo } from 'react';

interface BookingMode {
  /** Endereco da pagina publica; presente = agendamento externo. */
  slug: string;
}

const BookingModeContext = createContext<BookingMode | null>(null);

/**
 * Marca a arvore como agendamento publico. O wizard e os mesmos componentes da
 * area logada; o que muda e de onde vem o dado - as rotas `/public/*`, que nao
 * pedem sessao - e como o cliente se identifica: pelo WhatsApp, nao pela busca.
 */
export function BookingModeProvider({
  slug,
  children,
}: {
  slug: string;
  children: React.ReactNode;
}) {
  const value = useMemo(() => ({ slug }), [slug]);

  return <BookingModeContext.Provider value={value}>{children}</BookingModeContext.Provider>;
}

/** `null` dentro do sistema; com slug, na pagina publica. */
export function useBookingMode(): BookingMode | null {
  return useContext(BookingModeContext);
}
